module.exports = __webpack_public_path__ + "static/media/T.8f4fd3dd.png";